import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import * as Actions from '../../redux/actions';

const ReportDraft = ({ draft, timeField = 'updated', authToken, destroyReport }) => {
  const openDraft = () => {
    window.location.href = `/reports/edit?${draft.url}`;
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this draft report?')) return;
    destroyReport(draft.url, authToken);
  };

  const timeLabel = timeField === 'created' ? draft.created : draft.updated;
  const meta = [
    timeLabel,
    draft.completion?.tests > 0 ? `${draft.completion.tests} test${draft.completion.tests === 1 ? '' : 's'}` : null,
    draft.completion?.notes > 0 ? `${draft.completion.notes} note${draft.completion.notes === 1 ? '' : 's'}` : null,
  ].filter(Boolean).join(' · ');

  return (
    <div
      role="button"
      tabIndex={0}
      className="report-draft-row"
      onClick={openDraft}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDraft();
        }
      }}
    >
      <div className="report-draft-main">
        <div className="report-draft-title-line">
          <span className="report-draft-title">{draft.title}</span>
          {draft.author && (
            <span className="report-draft-author">by {draft.author}</span>
          )}
        </div>
        {meta ? <span className="report-draft-meta">{meta}</span> : null}
      </div>
      {draft.can_delete !== false && (
        <button
          type="button"
          className="report-draft-delete"
          aria-label={`Delete draft ${draft.title}`}
          onClick={handleDelete}
        >
          <DeleteOutlineIcon className="report-draft-delete-icon" />
        </button>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    authToken: state.authToken,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDraft);
